export const APP_ROUTES = {
  DASHBOARD: '/',
  POS: '/app/pos',
  PARTNERS: '/app/partners',
  ACTIVITIES_LOG: '/app/activities_log',
  PRICING_PLANS: '/app/pricing-plans',
  PRICING_CALLBACK: '/app/pricing-plans/callback',
  SETTINGS: '/app/settings',
  SETTINGS_STORE: '/app/settings/store',
  SETTINGS_INVOICE: '/app/settings/invoice_setting',
  SETTINGS_LANGUAGES: '/app/settings/languages',
  SETTINGS_ONLINE_STORE: '/app/settings/online_store',
  ORDERS: '/app/orders',
  ORDER_DETAIL: '/app/orders/:id',
  ORDER_CUSTOM: '/app/orders/:id/custom',
  ORDERS_DOWNLOAD_BY_LAYOUT: '/app/orders-download/:layout',
  DRAFT_ORDER_CREATE: '/app/orders/draft-order',
  DRAFT_ORDER_DETAIL: '/app/orders/draft-order/:id',
  ORDERS_SEND_EMAIL: '/app/orders/send_email',
  ORDERS_DOWNLOAD_FILE: '/app/orders/downloadfile',
  DRAFT_ORDERS_PRINT: '/app/draft_orders/:task/:id',
  DRAFT_ORDERS_SEND_EMAIL: '/app/draft_orders/send_email',
  ORDERS_PRINT_BY_TASK_AND_ID: '/app/orders/:task/:id',
  ORDERS_PRINT_BY_TASK: '/app/orders/:task',
  ORDERS_INLINE_PDF: '/app/orders/inline/:id',
  PDF_OUTPUT: '/pdfoutput',
  MODAL_VARIABLES: '/app/modal/variables/:textField',
  THEMES_EDIT: '/app/themes/edit/:id',
  THEMES_CODE: '/app/themes/code/:id',
  THEMES_VIEW: '/app/themes/view/:name',
  THEMES_TEMPLATES: '/app/themes/templates',
  SUBSCRIPTIONS: '/app/subscriptions',
  POPUP_SUBSCRIPTIONS: '/app/popup/subscriptions/:page',
  MODAL_PRICING: '/app/modal/pricing',
  INVOICE_GENERATOR: '/app/invoice_generator',
  INVOICE_GENERATOR_CREATE: '/app/invoice_generator/create',
  INVOICE_GENERATOR_EDIT: '/app/invoice_generator/edit/:id',
  INVOICE_GENERATOR_CUSTOMER_CREATE: '/app/invoice_generator/customer_create',
  INVOICE_GENERATOR_PRODUCT_CREATE: '/app/invoice_generator/product_create',
  INVOICE_GENERATOR_DELETE_CONFIRM: '/app/invoice_generator/delete_confirm',
  QUOTES_DETAIL: '/app/quotes/view/:id',
  QUOTES: '/app/quotes',
  QUOTES_EDIT: '/app/quotes/:id',
  QUOTES_CREATE: '/app/quotes/create',
  REPORTS: '/app/reports',
  REPORTS_CUSTOM_THEME: '/app/reports/custom-theme',
  ORDERS_DOWNLOADS: '/app/orders/downloads',
  AUTOMATIONS: '/app/automations',
  AUTOMATIONS_SHOPIFY_NOTI: '/app/automations/shopify-noti',
  AUTOMATIONS_HISTORY: '/app/automations/history',
  AUTOMATIONS_MANUAL_EMAIL: '/app/automations/manual-email',
  AUTOMATIONS_SHOPIFY_FLOW: '/app/automations/shopify-flow',
  AUTOMATIONS_SHOPIFY_FLOW_EDIT:
    '/app/automations/shopify-flow/edit/:actionType',
  AUTOMATIONS_CREATE: '/app/automations/create',
  AUTOMATIONS_EDIT: '/app/automations/edit/:id',
  TRANSLATION: '/app/translation',
  TEMPLATE_GALLERY: '/app/template_gallery',
  TEMPLATE_CUSTOMIZATION: '/app/template_customization',
  MODAL_TEMPLATES: '/app/modal/templates',
  ORDERS_MODAL_DOWNLOAD_SEND_MAIL: '/app/orders/modal/download-send-mail',
  ORDERS_PRINT_PDF: '/app/orders/:id/print-pdf',
  PRINT_REDIRECT: '/app/print/redirect/:layout',
  REVIEW: '/app/review',
  DEV: '/app/dev',
} as const

const DEV_MENU_VERCEL_ENVS = ['preview', 'development']
const DEV_MENU_MODES = ['development', 'test', 'staging']

// Vercel preview deployments are our staging environment, but `vite build` runs them
// with MODE=production, so VERCEL_ENV must take precedence over MODE when present.
export const resolveDevMenuEnabled = (
  vercelEnv: string | undefined,
  mode: string,
): boolean => {
  if (vercelEnv) return DEV_MENU_VERCEL_ENVS.includes(vercelEnv)
  return DEV_MENU_MODES.includes(mode)
}

export const isDevMenuEnabled = resolveDevMenuEnabled(
  import.meta.env.VITE_VERCEL_ENV,
  import.meta.env.MODE,
)

export const MENU_NAVIGATION: readonly {
  href: string
  label: string
  rel?: string
}[] = [
  { href: APP_ROUTES.ORDERS, label: 'Orders' },
  { href: APP_ROUTES.QUOTES, label: 'Quotes' },
  { href: APP_ROUTES.REPORTS, label: 'Reports' },
  { href: APP_ROUTES.TEMPLATE_CUSTOMIZATION, label: 'Customization' },
  { href: APP_ROUTES.AUTOMATIONS, label: 'Automation Emails' },
  { href: APP_ROUTES.SETTINGS, label: 'Settings' },
  { href: APP_ROUTES.PRICING_PLANS, label: 'Pricing' },
  ...(isDevMenuEnabled
    ? [{ href: APP_ROUTES.DEV, label: 'Developer 🔒' }]
    : []),
] as const

export type AppRoutes = (typeof APP_ROUTES)[keyof typeof APP_ROUTES]
